<template>
  <div>
            <div v-if="affichageReduit == false">
              <ubi-panel class="PostsList">
                <ubi-list-header
                        slot="header"
                        :limits="limits"
                        :total="results.total"
                        :page.sync="page"
                        :limit.sync="limit"
                        :sort.sync="sort"
                        :sortProperties="sortProperties"
                ></ubi-list-header>
                <ubi-list-selection
                        slot="selection"
                        v-model="selected"
                        :total="results.list.length"
                        @select="doSelect"
                ></ubi-list-selection>
                <template slot="actions">
                  <div v-if="!selected.length">
                    <el-button icon="export" size="mini" @click="exporter">
                      {{$t("general.selection.exportAll") }}
                    </el-button>
                    <el-button size="mini" @click="gestionAffichageReduit(true)" v-if="!affichageReduit">
                      <em class="el-icon-s-fold"></em>
                      {{$t("users.listMode") }}
                    </el-button>
                    <el-button size="mini" @click="gestionAffichageReduit(false)" v-if="affichageReduit">
                      <em class="el-icon-menu"></em>
                      {{$t("users.vignetteMode") }}
                    </el-button>
                  </div>
                  <div v-else>
                    <span class="inline">{{ $t("general.selection.forSelection") }} ({{ selected.length }}) :</span>
                    <el-button-group class="inline">
                      <el-button class="PostsList-export" size="mini" @click="exporter">{{ $t("general.selection.export")
                        }}
                      </el-button>
                      <el-button class="PostsList-export" size="mini"
                                 @click="$emit('modal-delete-list', {quantite: selected.length, selection: selected})"> {{ $t("posts.list.delete") }}
                      </el-button>
                      <el-button class="PostsList-export" size="mini"
                                 v-if="annonceFlux === false"
                                 @click="$emit('switch-published', selected)">{{ $t("general.selection.activateDeactivate") }}
                      </el-button>
                      <el-button class="PostsList-export" size="mini"
                                 v-if="saisit_en_ligne"
                                 @click="$emit('change-contacts', { selection: selected })">{{ $t("general.selection.changeContact") }}
                      </el-button>
                      <el-button class="PostsList-export" size="mini"
                                 v-if="saisit_en_ligne && hasMultiAccounts"
                                 @click="$emit('change-users', { selection: selected })">{{ $t("posts.list.assignUser") }}
                      </el-button>
                    </el-button-group>
                  </div>
                </template>
                <ubi-list-footer
                        slot="footer"
                        v-if="results.total > 1"
                        :limits="limits"
                        :total="results.total"
                        :page.sync="page"
                        :limit.sync="limit"
                        :sort.sync="sort"
                        :sortProperties="sortProperties"
                ></ubi-list-footer>
                <ubi-card-container :data="results.list">
                  <template
                          v-slot="{
                                  row: {
                                    id,
                                    titre,
                                    dateCreation,
                                    dateModification,
                                    etat,
                                    prix,
                                    prixDisplay,
                                    reference,
                                    donnees,
                                    photoPrincipale,
                                    type,
                                    sellType,
                                    published,
                                    nbContactsMailtracking,
                                    typeObjet,
                                    sourceCode
                                  }
                                }"
                  >
                    <ubi-card
                            class="PostsList-item PostItem"
                            v-model="selected"
                            :label="id"
                            :published="published"
                            :etat="etat"
                            :id="id"
                            full-width
                            :sourceCode="sourceCode"
                            @update:published="$emit('switch-published',id, $event)"
                            @input="handleSelect(id, $event)"
                    >
                      <template v-slot:header>
                        <div class="header-title">
                          <div><h3 class="ellipsify-title-card">{{titre}}</h3></div>
                          <div class="PostItem-reference ellipsify-reference-card" v-if="etat !== 'M'">Réf: {{reference}}</div>
                        </div>
                        <div class="PostItem-price">{{ prixDisplay }}</div>
                        <div class="PostItem-date">
                          <p class="date-creation-card">{{ $t("components.card.createdOn") }} <strong>{{ dateCreation.substring(0,16) }}</strong></p>
                          <p class="date-modification-card">{{ $t("components.card.updatedOn") }} <strong>{{ dateModification.substring(0,16) }}</strong></p>
                        </div>
                      </template>

                      <img v-if="photoPrincipale != null" :src="photoPrincipale.url" height="350" alt=""/>
                      <div v-else style="text-align: center;">
                        <ubi-icon class="no-photo" name="camera" size='350'/>
                      </div>

                      <template v-slot:footer>
                        <div class="PostItem-actions">
                          <div class="PostItem-buttons">
                            <div class="font-secondary">{{ $t("posts.card.actionsOnThisAd") }}</div>
                            <el-button-group>
                              <el-button v-if="typeObjet < 3000 || typeObjet >= 4000"
                                         :to="{ name: 'post-view', params: { post: id } }"
                                         size="mini"
                                         plain
                              >
                                <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
                              </el-button>
                              <el-button
                                      v-if="saisit_en_ligne && (!isSubUser || (isSubUser && etat !== 'M'))"
                                      :to="{ name: 'post-edit', params: { id: id }, query: { saisie: sourceCode } }"
                                      size="mini"
                                      plain
                              >
                                <span @click="eventAnalytics('edit_fiche')">{{ $t("posts.card.edit") }}</span>
                              </el-button>
                              <el-button
                                      v-if="hasSocialPostsAccess && etat !== 'M' && etat != 'B'"
                                      :to="{ name: 'manage-posts', params: { id: id } }"
                                      size="mini"
                                      plain
                              >
                                <span @click="eventAnalytics('manage-posts')">{{ $t("posts.card.managePosts") }}</span>
                              </el-button>
                              <el-button :to="{name :'portals-selection-post', params: { post : id }}"
                                         v-if="etat != 'M' && etat != 'B'"
                                         size="mini"
                                         plain>
                                <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
                              </el-button>
                              <el-dropdown @command="handleCommand" placement="top">
                                <el-button
                                        size="mini"
                                        icon="more-alt"
                                        type="info"
                                        icon-align="right"
                                        @click.prevent.native
                                        v-if="saisit_en_ligne
                                                            || sitimmoUser.garantiePublication && etat != 'M'"
                                ></el-button>
                                <el-dropdown-menu
                                        slot="dropdown"
                                        :append-to-body="false"
                                        :style="{
                                                                width: '200px',
                                                                transition: 'opacity 0.3s ease'
                                                              }"
                                        :popper-options="{
                                                                preventOverflowOrder: []
                                                              }"
                                >
                                  <!--<el-dropdown-item @click="onSwitchPublished(null, id)">Activer/Désactiver</el-dropdown-item>-->
                                  <el-dropdown-item v-if="saisit_en_ligne && etat == 'M'"
                                                    :command="{name: 'useModel', id: id}">
                                    {{ $t("posts.card.useThisModel") }}
                                  </el-dropdown-item>
                                  <el-dropdown-item v-if="saisit_en_ligne && etat != 'M'"
                                                    :command="{name: 'duplicate', id: id}">
                                    {{ $t("posts.card.duplicate") }}
                                  </el-dropdown-item>
                                  <el-dropdown-item v-if="!donnees.date_debut_diffusion && etat !== 'M' && etat !== 'A'"
                                                    :command="{name: 'diffuseLater', id, diffuseLaterDate: donnees.date_debut_diffusion}">
                                    {{$t('posts.list.diffuseLater.planDiffusion')}}
                                  </el-dropdown-item>
                                  <el-dropdown-item
                                          v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur && etat !== 'M' && etat !== 'A'"
                                          :command="{name: 'diffuseLater', id, diffuseLaterDate: donnees.date_debut_diffusion}">
                                    {{$t('posts.list.diffuseLater.reportDiffusion')}}
                                  </el-dropdown-item>
                                  <el-dropdown-item v-if="sitimmoUser.garantiePublication && etat != 'M'"
                                                    :command="{name: 'attendanceReport', id: id}">
                                    {{ $t("posts.card.presenceReport") }}
                                  </el-dropdown-item>
                                  <el-dropdown-item v-if="saisit_en_ligne && (!isSubUser || (isSubUser && etat !== 'M'))"
                                                    :command="{name: 'delete', id: id}">
                                    <a>{{ $t("posts.card.delete") }}</a>
                                  </el-dropdown-item>
                                  <el-dropdown-item :command="{name: 'private-note', id: id}" v-if="etat !== 'M'">
                                    {{ $t("posts.card.privateNote") }}
                                  </el-dropdown-item>
                                  <!--<el-dropdown-item>Enrichir</el-dropdown-item>-->
                                </el-dropdown-menu>
                              </el-dropdown>
                            </el-button-group>
                          </div>

                          <div class="PostItem-contacts"
                               v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur">
                            <em class="el-icon-date" style="font-size: 2em;"></em>

                            <div class="PostItem-contacts-label text-center">
                              {{$t('posts.list.diffuseLater.diffusedAt')}} <br>
                              {{donnees.date_debut_diffusion.valeur}}
                            </div>
                          </div>

                          <div class="PostItem-contacts" v-if="possedeContactManager === true">
                            <router-link :to="{ name: 'contacts-posts-detail', params: { post: reference}}">
                              <div class="PostItem-contacts-value text-center">{{nbContactsMailtracking}}</div>
                              <div class="PostItem-contacts-label text-center">
                                {{
                                $t("posts.card.contacts")
                                }}
                              </div>
                            </router-link>
                          </div>
                        </div>
                      </template>
                    </ubi-card>
                  </template>
                </ubi-card-container>
              </ubi-panel>
            </div>
  </div>
</template>

<script>
import ElButton from '@/components/Button'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { exportXlsPosts } from '@/services/posts'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPanel from '@/components/Panel.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListSelection from '@/components/lists/ListSelection.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import UbiCardContainer from '@/components/CardContainer.vue'
import UbiCard from '@/components/Card.vue'

export default {
  name: 'CardsListVo',
  components: {
    UbiCard,
    UbiCardContainer,
    UbiListFooter,
    UbiListSelection,
    UbiListHeader,
    UbiPanel,
    ElButton
  },
  props: ['affichageReduit', 'limits', 'total', 'sortProperties', 'results'],
  data () {
    return {
      referenceDuplication: null,
      selected: []
    }
  },
  computed: {
    ...mapState('postsVo', ['filter', 'saisieEnLigne', 'annonceFlux']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    saisit_en_ligne () {
      return (getFromSnake(this.sitimmoUser, 'saisit_annonces_en_ligne') || (getFromSnake(this.sitimmoUser, 'saisit_en_ligne_et_flux')))
    },
    userRS () {
      return this.$store.getters.getUser.socialNetworkIds
    },
    hasSocialPostsAccess () {
      return this.userRS.length > 0 && this.sitimmoUser.packSocialManagement
    },
    packExpert () {
      return this.sitimmoUser.packDiffusion === 'pack_expert'
    },
    garantiePublication () {
      return this.sitimmoUser.garantiePublication === 'true'
    },
    nbStocks () {
      return this.sitimmoUser.stocks.length
    },
    stocks () {
      return this.sitimmoUser.stocks
    },
    saveFilters () {
      return this.$store.state.saveFilters
    },
    userFilter () {
      return this.filter.user
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setPage(value)
        this.$store.dispatch('postsVo/loadPosts')
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.$store.dispatch('postsVo/loadPosts')
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      async set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.filter.page = 1
        this.$emit('load-data')
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduire: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 47)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    reduireRef: function (value) {
      if (!value) return ''
      value = value.toString().substr(0, 15)
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    loadingStatus: function () {
      this.selected = []
    }
  },
  methods: {
    ...mapMutations('postsVo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'setObjectType',
      'setLoadingStatus',
      'setCurrentId',
      'setModalDuplicate',
      'setModalDelete',
      'setModalUseModel',
      'setSelection'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    handleSelect (row, selection) {
      this.selected = selection
      this.setSelection(selection)
    },
    async doSelect (type) {
      this.selected = []
      if (type === '*') {
        const tmpSelection = this.results.list.map(({ id }) => id)
        this.selected = this.selected.concat(tmpSelection)
        this.setSelection(this.selected)
      }
      if (type === null) {
        const tmpSelection = this.results.list.map(({ id }) => id)
        this.selected = []
        this.setSelection([])
      }
    },
    async exporter () {
      this.loading = true
      let i = 0
      let strSelectedIds = null
      this.selected.forEach(function (idSelected) {
        if (i === 0) {
          strSelectedIds = idSelected
        } else {
          strSelectedIds = strSelectedIds + ',' + idSelected
        }
        i++
      })

      const res = await exportXlsPosts(this.filter, strSelectedIds, false, this.$t('posts.list.filenameExportAds'))
      this.$message(res)
      this.loading = false
    },
    handleCommand (command) {
      if (command.name === 'delete') {
        this.setCurrentId(command.id)
        this.setModalDelete(true)
      } else if (command.name === 'useModel') {
        this.setCurrentId(command.id)
        this.setModalUseModel(true)
      } else if (command.name === 'switch-published') {
        this.$emit('switch-published', command.id)
      } else if (command.name === 'duplicate') {
        this.setCurrentId(command.id)
        this.setModalDuplicate(true)
        // this.$emit('open-duplicate-modal', command.id)
      } else if (command.name === 'edit') {
        this.$router.push({
          name: 'post-edit',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'attendanceReport') {
        this.eventAnalytics('rapport_presence')
        this.$router.push({ name: 'attendance-report-post', params: { post: command.id } })
      } else if (command.name === 'diffuseLater') {
        this.eventAnalytics('programmer_diffusion')
        this.$emit('diffuse-later', { id: command.id, diffuseLaterDate: command.diffuseLaterDate })
      } else if (command.name === 'private-note') {
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      }
    },
    gestionAffichageReduit (rep) {
      this.$emit('affichage-reduit', rep)
    }
  }

}
</script>
<style lang="scss" scoped>
.header-title {
  display: flex;
  justify-content: space-between;
  .ellipsify-title-card {
    max-width: 280px;
    height: 20px;
    text-transform: capitalize;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
  .ellipsify-reference-card {
    max-width: 180px;
    height: 20px;
    text-transform: capitalize;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
.date-creation-card {
  font-size: 12px;
  width: max-content;
  transform: translateX(15px);
  margin-top: -8px;
}
.date-modification-card {
  margin-top: -15px;
  font-size: 12px;
  margin-bottom: -15px;
}
</style>
